import React, { useCallback, useState, useEffect, useRef } from 'react';

import clsx from 'clsx';
import PropTypes, { element } from 'prop-types';
import { Box, Button, ListItem, makeStyles, Typography } from '@material-ui/core';

import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router';

import SplashScreen from 'src/components/SplashScreen';
import functionalitiesService, {
  funcionalidades,
  msgOpcionNoDisponible
} from 'src/services/functionalitiesService';
import getOS from '../../../hooks/getOS';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import qrService, { toResponseReadQR } from '../../../services/qrService';
import GAException from '../../../components/GAException';
import { useSelector } from 'react-redux';
import { set } from 'lodash';

const useStyles = makeStyles((theme) => ({
  item: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  itemLeaf: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    width: 'auto',
  },
  button: {
    color: '#fff',
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    //width: '100%'
  },
  buttonLeaf: {
    color: '#fff',
    padding: '0',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    //width: '100%',
    fontWeight: theme.typography.fontWeightRegular,
    '&.depth-0': {
      '& $title': {
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    minWidth: 0
  },
  icon: {
    width: '20px',
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1),
    color: theme.palette.tertiary.main,
  },
  iconLabel: {
    color: theme.palette.tertiary.main,
    fontSize: '10px',
  },
  endIcon: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.tertiary.main,
  },
  title: {
    marginRight: 'auto'
  },
  active: {
    color: '#fff',
    '& $title': {
      fontWeight: theme.typography.fontWeightMedium
    },
    '& $icon': {
      color: theme.palette.tertiary.main,
    }
  }
}));

function BottomItem({
  title,
  href,
  depth,
  children,
  icon: Icon,
  endIcon: EndIcon,
  className,
  open: openProp,
  info: Info,
  onLogoutClick: onLogoutClick,
  ...rest
}) {
  const classes = useStyles();
  const [isMobile, setIsMobile] = useState( (getOS() === 'Android'));
  const [isMobileIos, setIsMobileIos] = useState((getOS() === 'iPhone'));
  const [appVersion, setAppVersion] = useState(localStorage.getItem('appVersion'));
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const isMountedRef = useIsMountedRef();
  const [isLoading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.account);
  // Ref para mantener referencia del listener activo
  const qrListenerRef = useRef(null);

    // Función para remover listener de QR - limpia recursos
  const removeQrListener = useCallback(() => {
    if (!qrListenerRef.current) return; // Nada que remover
    // Remover del mismo target donde se agregó
    if (getOS() === 'Android' && window.ReactNativeWebView) {
      document.removeEventListener('message', qrListenerRef.current);
    } else {
      window.removeEventListener('message', qrListenerRef.current);
    }
    qrListenerRef.current = null; // Limpiar referencia
  }, []);

 // Función principal para procesar datos del QR - useCallback evita referencias obsoletas
 const readQrfunction = useCallback((event) => {
      setLoading(true);

      

      if (!isMountedRef.current) {
          
          removeQrListener();
          setLoading(false);
        return; // Evita ejecución si componente desmontado
      }
      
   
      
      //pasar a Json
      let parseQr = JSON.parse(event);     
       if (!parseQr?.detail || parseQr.detail.trim() === '') {
        
          removeQrListener();
          setLoading(false);
        return; // Salir silenciosamente si no hay datos de QR válidos
      } 
      
      
      try {
        // setLoading(true);


        // console.log('qrCobro', qrCobro);
        // const tpdimo = JSON.parse(localStorage.getItem('tpdimo'));
        // Llamada al servicio para procesar el QR escaneado
        qrService.readQR(parseQr?.detail, '', null)
          .then((response) => {
            // setLoading(false);
            const qrReadData = toResponseReadQR(response);

            // console.log('response', JSON.stringify(response,null,2));
            // console.log('qrReadData', JSON.stringify(qrReadData,null,2));

            const data = {};

            const importeQR = qrReadData.importe / 100;

            // Mapeo de datos del QR a estructura interna
            data.titularName = qrReadData.titularDestino; // Nombre Comercial, para compras con QR
            data.accountNumber = qrReadData.cuentaAbono; // Codigo de Comercio, para compras con QR
            data.amount = importeQR;
            data.info = qrReadData.info;

            // Determinación del tipo de QR según glosa
            if (qrReadData.glosa === 'CCAHOD') {
              data.accountType = 'QRCOOP'; // QRCOOP
            }
            if (qrReadData.glosa === 'TCD') {
              data.accountType = 'QRTC'; // QRTC
            }
            if (qrReadData.glosa === 'TPD') {
              data.accountType = 'QRTP'; // QRTP
            } else if (!data.hasOwnProperty("accountType")) {
              data.accountType = `QR${qrReadData.origenQr}`;
            }
            data.idQr = qrReadData.idQr;
            data.codComercio = qrReadData.codComercio;
            data.cardData = {
              EMISOR: qrReadData.codEf,
              NUMERO_TARJETA: qrReadData.cuentaAbono,
              DOCUMENTO: qrReadData.ciNitDestino,
              NOMBRE_USUARIO: qrReadData.titularDestino,
              TAR_MASK: '',
              MONTO: importeQR,
              datosAdicionales: []
            };
            data.tipoQr = qrReadData.tipoQr;
            data.origenQr = qrReadData.origenQr;
            data.cuotas = qrReadData.cuotas;
            data.codOperacion = qrReadData.codOperacion;
            data.codDestinatario = qrReadData.codDestinatario;
            data.idOperacionCaja = qrReadData.idOperacionCaja;
            // Si se ha enviado un codigo de Comercio dentro de las propiedas leidas del QR
            if (qrReadData.codComercio !== null && qrReadData.codComercio !== '') {
              data.accountType = 'QRCOMERCIO';
              data.accountNumber = qrReadData.codComercio;
              data.cardData.NUMERO_TARJETA = qrReadData.codComercio;
              if (qrReadData.origenQr !== 'BANCARD') {
                data.idTransaccionQr = qrReadData.idTransaccionQr;
              }
            }
            if (data.origenQr === 'BANCARDATM') {
              data.timestamp = qrReadData.timestamp;
              data.orgId = qrReadData.orgId;
              data.terminalDsc = qrReadData.terminalDsc;
              data.terminalId = qrReadData.terminalId;
            }

            // Determinar ruta según tipo de QR
            let pathQr = '/app/leer/qr/origen';

            if (data.accountType === 'QRDIMOPROMOCION') {
              pathQr = '/app/promociones/qr';
            }
            if(window.ReactNativeWebView){
              removeQrListener(); // Limpiar listener después del procesamiento exitoso
            }
            // setLoading(false);

            history.push({
              pathname: pathQr,
              state: {
                destinationData: data,
                titleName: data.codOperacion,
              }
            });
          })
          .catch((response) => {
            if(window.ReactNativeWebView){
              removeQrListener(); // Limpiar listener en caso de error
            }

          setLoading(false);
           enqueueSnackbar(response.error ? "readQrfunction: " + response.error.message
              : 'No se pudo leer el Codigo QR. Favor vuelva a intentarlo mas tarde', {
              variant: 'error'
            });


            // console.log('Error: ' + response);
          });
      } catch (error) {
        // GAException(error);
          if(window.ReactNativeWebView){
            removeQrListener(); // Limpiar listener en caso de excepción
        }
        

        setLoading(false);
        enqueueSnackbar('Something went wrong', {
          variant: 'error'
        });
      } 
      // finally {
      //   setLoading(false);
      // }
    }, [isMountedRef]);

  // Función para agregar listener de QR - useCallback evita recreación innecesaria
  const addQrListener = useCallback(() => {
    if (qrListenerRef.current) return; // Ya agregado - evita duplicados
    const listener = (e) => readQrfunction(e.data);
    qrListenerRef.current = listener;
    // Diferente event target según plataforma
    if (getOS() === 'Android' && window.ReactNativeWebView) {
      document.addEventListener('message', listener);
    } else {
      window.addEventListener('message', listener);
    }
  }, [readQrfunction]); // Dependencia crítica: se actualiza si readQrfunction cambia



  // Cleanup de listeners al desmontar - previene memory leaks
  useEffect(() => {
    return () => {
      removeQrListener(); // Limpia al desmontar componente
    };
  }, [removeQrListener]);
  
  const handleOnclick = () => {
    try{
      // Validar usuario activado antes de permitir acceso
      if(user.flagUserActivate === false || user.flagUsuarioValidadoATC === false){
        enqueueSnackbar("Para acceder a esta opción, debes completar tu registro.", {
          variant: 'info'
        });
        return;
      }
      let funcionalidadKey = "";

      // Mapear href a funcionalidad específica
      if (href === "/app/cooperativas")
      {
        funcionalidadKey = funcionalidades.COOP.key;
      } else if (href === "/app/leer/qr"){
        funcionalidadKey = funcionalidades.QRCOMPRAS.key;
      } else if (href === '/app/recargasaldo') {
        funcionalidadKey = funcionalidades.RECARGASALDO.key;
      }

      // Verificar disponibilidad de funcionalidad
      if (funcionalidadKey !== "") {
        setLoading(true);
        functionalitiesService.funcionalidadHabilitada({codigo: funcionalidadKey})
          .then((response) => {
            setLoading(false);
            if (response === true)
            {
              // if ((isMobile || isMobileIos) && funcionalidadKey === 'QRCOMPRAS') {
              if ((window.ReactNativeWebView) && funcionalidadKey === 'QRCOMPRAS') {
                try {
                  //pasar a react native el evento y que abra la camara y lea el qr
                  window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'readQr' }));
                } catch (e) {
                  enqueueSnackbar('No se pudo abrir la camara', {
                    variant: 'error'
                  });

                }
                // //RECIBIR EL EVENTO DE REACT NATIVE SI ES ANDROID
                // if (isMobile) {
                //   document.addEventListener("message", function (event) {
                //     readQrfunction(event.data);
                //   });
                // }

                //RECIBIR EL EVENTO DE REACT NATIVE SI ES IOS
                // if (isMobileIos) {
                //   window.addEventListener("message", function (event) {
                //     readQrfunction(event.data);
                //   });
                // }
                if(window.ReactNativeWebView){
                  addQrListener(); // Agregar listener para recibir datos del QR
                }


              } else {
                history.push(href); // Navegación normal para otras funcionalidades
              }

            } else {
              // Funcionalidad no disponible
              if(window.ReactNativeWebView){
                removeQrListener(); // Limpiar cualquier listener activo
              }

              enqueueSnackbar(msgOpcionNoDisponible, {
                variant: 'info'
              });
            }
          })
          .catch(()=> {
             if(window.ReactNativeWebView){
              removeQrListener(); // Limpiar listener en caso de error de verificación
             }

            setLoading(false);
            enqueueSnackbar(msgOpcionNoDisponible, {
              variant: 'info'
            });
          });
      } else {
        history.push(href); // Navegación directa si no requiere verificación
      }
    } catch (error) {
        if(window.ReactNativeWebView){
          removeQrListener(); // Limpiar listener en caso de excepción
        }

      setLoading(false);
      enqueueSnackbar(msgOpcionNoDisponible, {
        variant: 'info'
      });
    }
  };

  if (isLoading) {
    return <SplashScreen />
  }

  return (
    <ListItem
      className={clsx(classes.itemLeaf, className)}
      disableGutters
      key={title}
      {...rest}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        <Button
          activeClassName={classes.active}
          className={clsx(classes.buttonLeaf, `depth-${depth}`)}
          //component={onLogoutClick ? Button : RouterLink}
          //onClick={onLogoutClick ? onLogoutClick : ''}
          //exact
          //to={href}
          onClick={onLogoutClick ? onLogoutClick : handleOnclick}
        >
          {Icon && (
            <Icon
              className={classes.icon}
              size="20"
            />
          )}
        </Button>
        <Typography
          className={classes.iconLabel}
          variant="h6"
        >
          {title}
        </Typography>
      </Box>
    </ListItem>
  );
}

BottomItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.any,
  endIcon: PropTypes.any,
  info: PropTypes.any,
  open: PropTypes.bool,
  title: PropTypes.string
};

BottomItem.defaultProps = {
  open: false
};

export default BottomItem;
